import React from "react";

export default function Loader() {
  return (
    <>
      <div className="overlay">
        <div className="loader"></div>
      </div>
    </>
  );
}
